import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import {
  ActionSheet,
  Button,
  Calendar,
  Cell,
  CellGroup,
  Col,
  Collapse,
  CollapseItem,
  Empty,
  Field,
  Form,
  Icon,
  List,
  Loading,
  NavBar,
  Popover,
  Popup,
  PullRefresh,
  Row,
  DatePicker,
  Search,
  Tab,
  Tabbar,
  TabbarItem,
  Tabs,
  Area,
  Picker,
  TimePicker,
  Uploader,
  Image as VanImage,
  Toast
} from 'vant'
import 'vant/lib/index.css'

import { Table, Pagination, Button as AButton, Form as AForm, Input as AInput, Space, Select, DatePicker as ADatePicker, ConfigProvider } from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css'
import * as Icons from '@ant-design/icons-vue'

import LicensePlate from 'vue3-license-plate'
import 'vue3-license-plate/lib/licensePlate.css'

const app = createApp(App).use(router)
app.use(Icon)
app.use(Loading)
app.use(Button)
app.use(Row)
app.use(Col)
app.use(Search)
app.use(Tab)
app.use(Tabs)
app.use(List)
app.use(Empty)
app.use(NavBar)
app.use(PullRefresh)
app.use(Cell)
app.use(CellGroup)
app.use(Field)
app.use(Form)
app.use(Collapse)
app.use(CollapseItem)
app.use(ActionSheet)
app.use(Popup)
app.use(Calendar)
app.use(Tabbar)
app.use(TabbarItem)
app.use(Popover)
app.use(Area)
app.use(Picker)
app.use(Uploader)
app.use(VanImage)
app.use(DatePicker)
app.use(TimePicker)
app.use(Toast)

app.use(Table)
app.use(Pagination)
app.use(AButton)
app.use(AForm)
app.use(AInput)
app.use(ADatePicker)
app.use(ConfigProvider)
app.use(Space)
app.use(Select)
app.use(LicensePlate)

// 开始使用全局图标
const icons: any = Icons
for (const i in icons) {
  // 循环注册组件
  app.component(i, icons[i])
}

app.mount('#app')
